(() => {
  'use strict';
  if (window.AvonticGalaxySurfaceComparison) return;
  window.AvonticGalaxySurfaceComparison = true;
  const parse = el => { try { return JSON.parse(el?.textContent || 'null'); } catch { return null; } };
  const plainMoney = value => String(value || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '\u00a0');
  const text = (el, value) => { if (el) el.textContent = value; };
  const imageUrl = (url, width) => { const parsed = new URL(url, location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; };
  function price(container, variant, data, labels) {
    if (!container) return;
    const nodes = [];
    if (!variant && data.varies) { const from = document.createElement('span'); from.textContent = labels.from; nodes.push(from); }
    const current = document.createElement('strong'); current.textContent = plainMoney(variant?.price || data.minimum); nodes.push(current);
    if (variant?.compare) {
      if (data.separate) { const basis = document.createElement('small'); basis.textContent = labels.separate; nodes.push(basis); }
      const compare = document.createElement('s'); compare.textContent = plainMoney(variant.compare); nodes.push(compare);
    }
    container.replaceChildren(...nodes);
  }
  function render(pending = false) {
    document.querySelectorAll('[data-av-gs-comparison]').forEach(root => {
      const picker = document.querySelector('#avontic-primary-product variant-picker');
      const variant = pending ? null : parse(picker?.querySelector('script[data-variant]'));
      const labels = parse(root.querySelector('[data-av-gs-labels]')) || {};
      root.querySelectorAll('[data-av-gs-target]').forEach(card => {
        const data = parse(card.querySelector('[data-av-gs-data]')); if (!data) return;
        const match = variant?.options ? data.variants.find(v => v.options.length === variant.options.length && v.options.every((value, index) => value === variant.options[index])) : null;
        const link = card.querySelector('[data-av-gs-link]');
        if (link) link.href = match ? `${data.url}?variant=${match.id}` : data.url;
        text(card.querySelector('[data-av-gs-match]'), match ? labels.matched : labels.review);
        price(card.querySelector('.av-gs-card__price'), match, data, labels);
        const image = card.querySelector('.av-gs-card__media img');
        const source = match?.image || data.image;
        if (image && source) {
          image.srcset = [180, 360, 540, 720, 1080].map(width => `${imageUrl(source, width)} ${width}w`).join(', ');
          image.src = imageUrl(source, 1080);
        }
      });
    });
  }
  let frame;
  const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => render()); };
  document.addEventListener('change', event => {
    if (!event.target.closest?.('#avontic-primary-product variant-picker')) return;
    render(true);
  }, true);
  ['variant:change', 'product:rerender', 'shopify:section:load'].forEach(name => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  function start() {
    schedule();
    new MutationObserver(records => {
      if (records.some(record => record.target.closest?.('variant-picker') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('variant-picker, product-rerender') || node.querySelector?.('variant-picker'))))) schedule();
    }).observe(document.getElementById('main') || document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
